import { ChatAttachmentWarning } from '@agent/agent-interface/contact-view/chat/model/chat-attachment-error';
import { FILE_MAX_SIZE, MAX_ATTACHMENT_COUNT } from '@agent/agent-interface/contact-view/chat/services/chat-attachment.service';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'chat-attachment-layer',
  templateUrl: 'chat-attachment-layer.component.html',
  styleUrls: ['./chat-attachment-layer.component.scss'],
})
export class ChatAttachmentLayerComponent {
  @Input()
  public files: File[];

  @Input()
  public warnings: ChatAttachmentWarning[];

  @Output()
  public onRemoveFile: EventEmitter<any> = new EventEmitter();

  @Output()
  public onRemoveWarning: EventEmitter<any> = new EventEmitter();

  private fileMaxSize = FILE_MAX_SIZE / 1000000;

  get count() {
    return MAX_ATTACHMENT_COUNT;
  }

  get maxSize() {
    return this.fileMaxSize;
  }

  remove(file) {
    if (this.onRemoveFile) {
      this.onRemoveFile.emit(file);
    }
  }

  removeWarning(warning) {
    if (this.onRemoveWarning) {
      this.onRemoveWarning.emit(warning);
    }
  }
}
